
import React from 'react';

const EuroCurrencyUnderline = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			fill="none"
			viewBox="0 0 32 32"
		>
			<path
				fill="#2d2d2d"
				d="M24.51 13.08C23.29 9.55 19.94 7 16 7c-3.94 0-7.29 2.55-8.51 6.08A6.48 6.48 0 002 19.5C2 23.08 4.92 26 8.5 26c1.58 0 3.1-.58 4.27-1.61a8.823 8.823 0 006.45 0A6.516 6.516 0 0023.5 26c3.58 0 6.5-2.92 6.5-6.5a6.48 6.48 0 00-5.49-6.42zM8.5 24C6.02 24 4 21.98 4 19.5c0-1.97 1.25-3.64 3.04-4.25-.02.25-.04.5-.04.75 0 3.03 1.51 5.7 3.81 7.34-.7.41-1.49.66-2.31.66zm.5-8c0-3.86 3.14-7 7-7s7 3.14 7 7-3.14 7-7 7-7-3.14-7-7zm14.5 8c-.82 0-1.61-.25-2.31-.66C23.49 21.7 25 19.03 25 16c0-.25-.02-.5-.04-.75 1.79.61 3.04 2.28 3.04 4.25 0 2.48-2.02 4.5-4.5 4.5z"
			></path>
			<path
				fill="#2d2d2d"
				d="M17 13c.52 0 1.02.14 1.5.42l1.01-1.73c-.79-.46-1.64-.69-2.51-.69-2.76 0-5 2.24-5 5s2.24 5 5 5c.87 0 1.71-.23 2.5-.69l-1-1.73c-.48.28-.99.42-1.5.42-1.3 0-2.4-.84-2.82-2H19v-2h-4.82c.42-1.16 1.52-2 2.82-2zM28 30H4v2h24v-2z"
			></path>
		</svg>
	);
};

export default EuroCurrencyUnderline;
